import { render, staticRenderFns } from "./type-image.vue?vue&type=template&id=72491f10&scoped=true&"
import script from "./type-image.vue?vue&type=script&lang=js&"
export * from "./type-image.vue?vue&type=script&lang=js&"
import style0 from "./type-image.vue?vue&type=style&index=0&id=72491f10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72491f10",
  null
  
)

export default component.exports